import { PropsWithChildren } from 'react';

import { useAddonsSpamexpertsSso } from '@newfold/huapi-js';

import SSOComponent from '../index';
import { SSO_HOOK_OPTIONS } from '../utils/helpers';
import { BaseSsoProps } from '../utils/types';

interface SpamExpertsSSOProps extends BaseSsoProps {
  addonId: number | string;
}

const SpamExpertsSSO = ({
  children = undefined,
  addonId,
  disabled = false,
  ...props
}: PropsWithChildren<SpamExpertsSSOProps>) => {
  const sso = useAddonsSpamexpertsSso(String(addonId), SSO_HOOK_OPTIONS);

  return (
    <SSOComponent sso={sso} isDisabled={disabled} {...props}>
      {children}
    </SSOComponent>
  );
};

export default SpamExpertsSSO;
